import React from 'react'

import { Button, Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { ReactComponent as MedicalRecordIcon } from 'static/svg/medical-record-icon.svg'

import * as S from './styles'

interface RememberCompleteMedicalRecordModalProps {
  onClose: () => void
  onSuccessAction: () => void
  patientName: string
}

export function RememberCompleteMedicalRecordModal({
  onClose,
  onSuccessAction,
  patientName,
}: RememberCompleteMedicalRecordModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle={
        <S.TitleContainer>
          <MedicalRecordIcon width={50} height={50} />
          <Typography
            center
            weight='bold'
            variant='content1'
          >
            Quer preencher o prontuário de <strong>{patientName}</strong> agora?
          </Typography>
        </S.TitleContainer>
      }
      onCloseModal={onClose}
    >
      <S.RememberCompleteMedicalRecordModalContainer>
        <S.ContentTop>
          <Typography
            center
            variant='content2'
          >
            Recomendamos preencher agora caso não possua uma consulta na sequência.
          </Typography>

          <Button
            variant='contained'
            onClick={onSuccessAction}
            uppercase={false}
          >
            Sim, preencher prontuário agora
          </Button>
        </S.ContentTop>

        <S.Separator>
          <span>ou</span>
        </S.Separator>

        <S.ContentBottom>
          <Button
            variant='contained'
            color='danger'
            onClick={onClose}
            uppercase={false}
          >
            Deixar para depois
          </Button>

          <Typography
            center
            variant='content2'
          >
            <strong>Atenção</strong>, é importante que você preencha todos os prontuários <strong>até o fim do dia</strong>.
          </Typography>
        </S.ContentBottom>
      </S.RememberCompleteMedicalRecordModalContainer>
    </ModalGeneric>
  )
}